import { render, staticRenderFns } from "./MenuHighlightButton.vue?vue&type=template&id=cfc299be&"
import script from "./MenuHighlightButton.vue?vue&type=script&lang=ts&"
export * from "./MenuHighlightButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports